import { ClientOffer } from '../../../shared/types/offers';

/**
 * Offer reference comment max length is 255 characters
 */
export function validateReferenceComment(comment?: string): boolean {
  if (!comment) {
    return true;
  }
  return comment.length <= 255;
}

/**
 * Check that all required offer details are filled in and valid
 * @param offer
 * @returns true if all required offer details are filled in and valid, false otherwise
 */
export const validateOfferDetails = (
  offer: Pick<
    ClientOffer,
    | 'customerName'
    | 'industry'
    | 'name'
    | 'pricingBasis'
    | 'dealProbability'
    | 'referenceComment'
  >,
) =>
  !!(
    offer.customerName &&
    offer.industry &&
    offer.name &&
    offer.pricingBasis &&
    Number.isInteger(offer.dealProbability) &&
    validateReferenceComment(offer.referenceComment)
  );
